import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import BlueButtonInWhite from './BlueButtonInWhite.tsx';

export default function CallToActionSection({
  gradient = "linear-gradient(to right, #2c2c2c, #000)",
  title,
  description,
  isList = false,
  buttonText,
  buttonLink,
  image,
}) {
  return (
    <Box
      sx={{

        overflow: "hidden",

      }}
    >
      <Grid container>
        <Grid item xs={12}
          md={6} >
          <Grid container sx={{ minHeight: { xs: '250px', md: '280px' }, flexDirection: 'column' }}>
            {/* TEXT */}
            <Grid
              item

              sx={{
                background: gradient,
                color: "white",
                px: { xs: 4, sm: 6, lg: 14 },
                py: 6,
                pb: { xs: 2, sm: 0, md: 6 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",


              }}
            >
              <Typography

                sx={{
                  fontWeight: 900,
                  color: "#D4A76A", // Dorado
                  mb: 2,
                  maxWidth: '550px',
                  textShadow: '6px 6px 6px rgba(0,0,0,0.2)',
                  fontSize: { xs: '24px', md: '28px', lg: '32px' },
                  lineHeight: 1.3
                }}
              >
                {title}
              </Typography>

              {/* TEXT or LIST */}
              {!isList ? (
                <Box
                  sx={{ fontSize: { xs: '14px', md: "15px", lg: '16px' }, color: "white", maxWidth: '600px', textShadow: '6px 6px 6px rgba(0,0,0,0.3)' }}
                  dangerouslySetInnerHTML={{ __html: description }}
                />

              ) : (
                <Box component="ol" sx={{ color: "white", mb: 4, pl: 0 }}>
                  {description.map((item, index) => (
                    <Box
                      component="li"
                      key={index}
                      sx={{
                        listStyle: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      {/* Número estilizado */}
                      <Box
                        sx={{
                          minWidth: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50rem",
                          background:
                            "linear-gradient(25deg,rgba(10, 98, 116, 0.69) 10%,rgba(19, 185, 218, 0.66))",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "14px",
                          boxShadow:
                            "2px 2px 4px rgba(0,0,0,0.6), -2px -2px 6px rgba(255,255,255,0.3)",
                        }}
                      >
                        {index + 1}
                      </Box>

                      {/* Texto */}
                      <Typography
                        component="span"
                        sx={{ fontSize: "16px", lineHeight: 1.6, textAlign: "left", textShadow: '6px 6px 6px rgba(0,0,0,0.8)' }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>

              )}


            </Grid>
            <Grid item sx={{ display: 'flex', justifyContent: 'flex-end', p: 4, pt: { xs: 0, md: 3 }, background: { xs: gradient, md: 'none' }, }}>
              {/* BUTTON */}

              <BlueButtonInWhite
                href={buttonLink || '/contacto'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography
                  sx={{
                    fontSize: { xs: '14px', sm: '16px' },
                    fontWeight: 600,
                  }}
                >
                  {buttonText || 'Agenda una cita'}
                </Typography>
              </BlueButtonInWhite>

            </Grid>
          </Grid>

        </Grid>
        {/* IMAGE */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxHeight: '350px',
              height: "100%",
              overflow: "hidden",
              "&:hover .image-overlay": {
                opacity: 0, // Se desvanece al hacer hover


              }
            }}
          >
            <Box
              component="img"
              src={image}
              alt="Imagen ilustrativa"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "0px 0px 0px 50px",
              }}
            />
            {/* Overlay oscuro */}
            <Box
              className="image-overlay"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: 'linear-gradient(90deg,rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
                transition: "opacity 0.3s ease",
                borderRadius: "0px 0px 0px 50px",
              }}
            />
          </Box>
        </Grid>

      </Grid>
    </Box>
  );
}
